<template>
  <div class="videos">
    <default-header />
    <v-main>
      <v-container>
        <default-videomain />
      </v-container>
    </v-main>
    <default-footer />
  </div>
</template>

<script>
export default {
  name: "videos",
  components: {
    "default-header": () => import("../../home/components/header/index.vue"),
    "default-footer": () => import("../../home/components/footer/index.vue"),
    "default-videomain": () => import("../components/video-main/index.vue"),
  },
};
</script>
